import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import type { SHARED_CONSTANTS_KNOWLEDGE_SOURCE } from "@lib/shared_constants.json";

import type { KnowledgeSourceDefinitionIdResult } from "../knowledgeSourceDefinitionId";

export type KnowledgeSourceDefinitionResult = KnowledgeSourceDefinitionIdResult;

interface BasePostKnowledgeSourceDefinitionProps {
  appGroupId: string;
  description?: string;
}

export interface PostCatalogKnowledgeSourceDefinitionProps extends BasePostKnowledgeSourceDefinitionProps {
  type: "catalog";
  catalogId: string;
}

export type PostKnowledgeSourceDefinitionProps = PostCatalogKnowledgeSourceDefinitionProps;

export type PostKnowledgeSourceDefinitionInvalidNameError = FetchUserEncodedError<
  SHARED_CONSTANTS_KNOWLEDGE_SOURCE["ERROR_CODES"]["INVALID_NAME"]
>;
export type PostKnowledgeSourceDefinitionInvalidDescriptionError = FetchUserEncodedError<
  SHARED_CONSTANTS_KNOWLEDGE_SOURCE["ERROR_CODES"]["INVALID_DESCRIPTION"]
>;
export type PostKnowledgeSourceDefinitionCatalogNotFoundError = FetchUserEncodedError<
  SHARED_CONSTANTS_KNOWLEDGE_SOURCE["ERROR_CODES"]["CATALOG_NOT_FOUND"]
>;
export type PostKnowledgeSourceDefinitionDuplicateCatalogError = FetchUserEncodedError<
  SHARED_CONSTANTS_KNOWLEDGE_SOURCE["ERROR_CODES"]["DUPLICATE_CATALOG"]
>;

export type PostKnowledgeSourceDefinitionErrors =
  | PostKnowledgeSourceDefinitionInvalidNameError
  | PostKnowledgeSourceDefinitionInvalidDescriptionError
  | PostKnowledgeSourceDefinitionCatalogNotFoundError
  | PostKnowledgeSourceDefinitionDuplicateCatalogError;

export const isPostKnowledgeSourceDefinitionError = (
  error: FetchRequestError
): error is PostKnowledgeSourceDefinitionErrors => {
  return error instanceof FetchUserEncodedError;
};
